module.exports = __webpack_public_path__ + "static/media/product.d8f0991b.jpg";